import { CardListItemCheckbox } from '@latitude/card-list-item';
import { FormCheckboxGroup } from 'components/FormCheckboxGroup';
import type { FieldValues } from 'react-hook-form';

import type {
  FormCheckboxCardListOption,
  FormCheckboxCardListProps,
} from './types';

const FormCheckboxCardList = <T extends FieldValues = FieldValues>(
  props: FormCheckboxCardListProps<T>,
) => (
  <FormCheckboxGroup<FormCheckboxCardListOption, T>
    {...props}
    render={(option, checkboxProps) => {
      const {
        checked,
        // Extract the props we need for CardListItemCheckbox
        disabled,
        invalid,
        onBlur,
        'data-testid': testId,
        onCheckedChange,
      } = checkboxProps;

      return (
        <CardListItemCheckbox
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled ?? option.disabled}
          invalid={invalid}
          onBlur={onBlur}
          checkboxTestId={testId}
          title={option.title}
          subtitle={option.subtitle}
          trailing={option.trailing}
        />
      );
    }}
  />
);

export default FormCheckboxCardList;
